import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { newsTypeLabel } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  horizontal?: boolean;
}

export default function NewsCard({ item, horizontal = false }: NewsCardProps) {
  if (horizontal) {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group flex cursor-pointer flex-col gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
      >
        <div className="relative h-40 w-full shrink-0 overflow-hidden rounded-md bg-primary-900 sm:h-28 sm:w-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 翔田千里动态资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
            <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{newsTypeLabel(item.type)}</span>
            <span>{item.date}</span>
          </div>
          <h3 className="mt-2 clamp-2 font-heading text-base leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {item.title}
          </h3>
          <p className="mt-1.5 clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-primary-900">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 翔田千里动态资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-medium text-primary-800 backdrop-blur">
          {newsTypeLabel(item.type)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <span className="text-[11px] tracking-wide text-foreground-500">{item.date}</span>
        <h3 className="mt-2 clamp-2 font-heading text-base leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="mt-auto inline-flex items-center gap-1 pt-3 text-xs text-accent-700">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
        </span>
      </div>
    </Link>
  );
}